import { Box, Button } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons"; // Import Chakra UI back icon
import { useState } from "react";
// import AddCust

import AddDriver from "./AddDriver";
import DriversList from "./DriversLIst";

const DriversContainer = () => {
  const [showCustomerList, setShowCustomerList] = useState(true);
  const [editingCustomer, setEditingCustomer] = useState(null); // Store the customer being edited

  const handleAddClient = () => {
    setEditingCustomer(null); // Reset editing data
    setShowCustomerList(false);
  };

  const handleEdit = (rowData) => {
    console.log("Edit clicked for:", rowData);
    setEditingCustomer(rowData); // Store customer data for editing
    setShowCustomerList(false);
  };

  const handleBack = () => {
    setEditingCustomer(null); // Reset editing state
    setShowCustomerList(true);
  };

  const handleDelete = (rowData) => {
    console.log("Delete clicked for:", rowData);
    // Implement delete logic
  };

  return (
    <>
      {showCustomerList ? (
        <DriversList
          handleAddClient={handleAddClient}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      ) : (
        <>
          <AddDriver driverData={editingCustomer} />
        </>
      )}
    </>
  );
};

export default DriversContainer;
